<!--  -->
<template>
  <div class="container">
    <!-- 轮播图部分 -->
    <div class="banner-container">
      <van-swipe :auto="true"
                 :show-indicators="true">
        <van-swipe-item v-for="(banner, index) in banners"
                        :key="index">
          <img :src="banner.src"
               alt="banner"
               style="width: 100%; height: 100%;" />
        </van-swipe-item>
      </van-swipe>
      <div class="indicator">{{ currentIndex + 1 }}/{{ banners.length }}</div>
    </div>
    <!-- 信息展示部分 -->
    <div class="information-container">
      <div class="name-wrap">
        <div class="name">{{ result?.name }}</div>
        <img src="../assets/jingshengongde.png"
             alt="taichi">
      </div>
    </div>
    <!-- 敬神功德简介部分 -->
    <div class="introduction-container">
      <div class="title">敬神功德简介</div>
      <div class="introduction">
        <p>
          {{ result?.introduce }}
        </p>
      </div>
    </div>
    <!-- 注意事项部分 -->
    <div class="introduction-container">
      <div class="title">注意事项</div>
      <div class="introduction">
        {{result?.attention}}
      </div>
    </div>
    <div class="block-72"></div>
    <div class="appointment-enter-container">
      <div class="appointment-enter"
           @click="toDonationRegistration">功德会善款</div>
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      currentIndex: 0,
      banners: [
        {
          src: "https://www.shqsm.cn/upload/temp/jingshenggongde1.jpg",
        },
        {
          src: "https://www.shqsm.cn/upload/temp/jingshenggongde2.jpg",
        },
        {
          src: "https://www.shqsm.cn/upload/temp/jingshenggongde3.jpg",
        },
      ],
      meritName: "功德会善款",
      result: {},
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    async donationData() {
      try {
        const data = await this.$http.get(`/tempt/api/sjte/TeMerits?id=${localStorage.getItem("DonationDetailId")}`); // 通过this.$http调用全局挂载的axios实例发送GET请求
        this.result = data.result; // 如果请求成功，将返回的数据赋值给data属性用于展示
        this.$store.commit("updateDonationDetail", this.result);
      } catch (error) {
        console.log("error")
      } finally {
        console.log("error2")
      }
    },
    toDonationRegistration() {
      this.$router.push("/DonationRegistration")
      localStorage.setItem("donationDetail", JSON.stringify(this.result));
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.donationData()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期 - 创建之前
  beforeMount() { }, // 生命周期 - 挂载之前
  beforeUpdate() { }, // 生命周期 - 更新之前
  updated() { }, // 生命周期 - 更新之后
  beforeDestroy() { }, // 生命周期 - 销毁之前
  destroyed() { }, // 生命周期 - 销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
.van-swipe {
  height: 100%;
}
.banner-container {
  height: 210px;
  position: relative;
}
.banner-container .indicator {
  position: absolute;
  right: 16px;
  bottom: 24px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  font-size: 10px;
  color: #fff;
  padding: 2px 8px;
}
.information-container {
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 16px 12px;
  margin: -15px 12px 0;
  position: relative;
  z-index: 10;
}
.information-container .address-wrap,
.information-container .contact-wrap,
.information-container .name-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.information-container .name-wrap .name {
  font-size: 22px;
  color: #000;
  font-weight: 600;
  font-family: PingFangSC-Semibold, PingFang SC;
}
.information-container .name-wrap img {
  width: 20px;
  height: 20px;
  margin-left: 8px;
}
.introduction-container {
  margin: 16px 16px 0;
}
.introduction-container .title {
  display: inline-block;
  font-size: 16px;
  color: #000;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.introduction-container .introduction {
  white-space: pre-line;
  margin-top: 6px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
.appointment-enter-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: 72px;
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    from(hsla(0, 0%, 93.3%, 0)),
    color-stop(81%, #fff)
  );
  background-image: linear-gradient(180deg, hsla(0, 0%, 93.3%, 0), #fff 81%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.appointment-enter-container .appointment-enter1,
.appointment-enter-container .appointment-enter {
  margin: 0 48px;
  font-size: 16px;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  color: #fff;
  text-align: center;
  border-radius: 22px;
  padding: 9px 0;
  -webkit-box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
}
.appointment-enter-container .appointment-enter {
  background: linear-gradient(133deg, #007aaa, #004e93);
}
</style>